import { useTranslation } from 'react-i18next';
import { News, ReminderMessageCategory } from 'all-in-one-shared-api';
import { PrimaryButton } from 'components';
import { StyledTitle } from 'components/StyledTitle';
import { GreetingBox } from './styledComponent';
import { isLocaleEnglish } from 'utils/languageUtils';

interface ReminderMessageProps {
  message?: News;
}

export const ReminderMessage = ({ message }: ReminderMessageProps) => {
  const { t, i18n } = useTranslation();

  if (!message) {
    return <></>;
  }

  const isEnglish = isLocaleEnglish(i18n.language);

  const formattedReminderMessage = {
    title: isEnglish ? message.title : message.chineseTitle,
    description: isEnglish ? message.message : message.chineseMessage,
    url: isEnglish ? message.link : message.chineseLink,
    imgSrc: message.imageUrl,
    messageCategory: message.messageCategory,
  };

  const allowRenderReminderButton = () => {
    if (formattedReminderMessage?.messageCategory !== ReminderMessageCategory.BIRTH_MONTH) {
      return true;
    }
    return !!formattedReminderMessage.url;
  };

  return (
    <GreetingBox isReminder={true}>
      <StyledTitle color="var(--white)" level={4}>
        {formattedReminderMessage.title}
      </StyledTitle>
      <StyledTitle color="var(--white)" fontWeight="normal" level={5}>
        {formattedReminderMessage.description}
      </StyledTitle>
      <div>
        {allowRenderReminderButton() && (
          <PrimaryButton size="middle" onClick={() => window.open(formattedReminderMessage.url)}>
            {t('home.reminderMsgButton')}
          </PrimaryButton>
        )}
      </div>
    </GreetingBox>
  );
};
